import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ModalDeleteItem from '../../Modal-Delete-Item';
import Objective from './Objective';
import { TabPaneStyles } from '../styles';
import { useKanban } from 'hooks/useKanban';

const TabPaneObjectives = ({ setStatus, objectives, setObjectives }) => {
  const { t: translate } = useTranslation();
  const { search } = window.location;
  const searchParams = new URLSearchParams(search);
  const accountParam = searchParams.get('id');
  const { kanban: paidMedia } = useKanban();
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  const [selectedObjective, setSelectedObjective] = useState(null);

  const toggleModal = () => {
    const willClose = isOpenModalDelete;
    setIsOpenModalDelete(!isOpenModalDelete);

    if (willClose) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const deleteObjective = async () => {
    return paidMedia.deleteTypeItem('objectives', selectedObjective.id);
  };

  return (
    <TabPaneStyles>
      <span>{translate('Objectives')}</span>
      <div className="d-flex flex-column gap-2">
        {objectives &&
          objectives.map((objective) => (
            <Objective
              key={objective.id}
              id={objective.id}
              name={objective.name}
              setItems={setObjectives}
              index={objectives.findIndex((col) => col.id === objective.id)}
              total={objectives.length}
              accountParam={accountParam}
              isNew={objective.isNew}
              setSelectedItem={setSelectedObjective}
              setIsOpenModalDelete={setIsOpenModalDelete}
              setStatus={setStatus}
            />
          ))}
        <Button
          color="outline"
          style={{ width: '37.5rem' }}
          onClick={() =>
            setObjectives([
              ...objectives,
              { id: `temp-${objectives.length + 1}`, name: '', isNew: true },
            ])
          }
        >
          <i className="bx bx-plus" />
          {translate('Add objective')}
        </Button>
      </div>
      <ModalDeleteItem
        isOpen={isOpenModalDelete}
        toggle={toggleModal}
        item={selectedObjective}
        setItems={setObjectives}
        setStatus={setStatus}
        onDelete={deleteObjective}
        headerText="Delete objective"
        bodyText="Are you sure you want to delete the objective {{item}}?"
      />
    </TabPaneStyles>
  );
};

TabPaneObjectives.propTypes = {
  setStatus: PropTypes.func.isRequired,
  objectives: PropTypes.array.isRequired,
  setObjectives: PropTypes.func.isRequired,
};

export default TabPaneObjectives;
